module.exports = __webpack_public_path__ + "static/media/resultats_or2022.d19d2ae9.jpg";